// Flight.js
import axios from "axios";

async function Flight(flightData, userLocation) {
  if (userLocation.lat === null || userLocation.lng === null) return;
  
  const options = {
    method: 'GET',
    url: `https://fr24api.flightradar24.com/api/live/flight-positions/full?bounds=${userLocation.lat + 1},${userLocation.lat - 1},${userLocation.lng - 1},${userLocation.lng + 1}`
    + '&limit=5',
    headers: {
      Accept: 'application/json',
      'Accept-Version': 'v1',
      Authorization: 'Bearer 9d73d354-5af7-4b99-b1dc-1b17c89470c0|Y0UyLNPIhcZbXLk062qxoe367itFtZ4CnUzxbkxQ950bc4ad',
    }
  };
  
  try {
    const response = await axios.request(options);
    response.data.data.forEach(flight => {
      flightData.push(flight);
      console.log(`Flight ${flight.callsign}: Latitude ${flight.lat}, Longitude ${flight.lon}, Altitude ${flight.alt} feet`);
    });
  } catch (error) {
    console.error("Failed to fetch flight data:", error);
  }
}

export default Flight;
